
<!-- Content area for spinner and text -->
<div class="content-container">

  <!-- Left side: Spinner -->
  <div class="spinner-container">
    <ion-spinner name="crescent" color="primary"></ion-spinner>
  </div>

  <!-- Right side: Text -->
  <div class="text-container">
    <div class="modal-div" [innerHtml]="syncMessage | safeHtml"></div>
  </div>

</div>

<div *ngIf="!showCancel" class="bottom-margin"></div>

<div class="modal-buttons ion-text-center">
  <ion-button *ngIf="showCancel" fill="clear" class="modal-button" (click)="dismiss()">{{ modalDismiss }}</ion-button>
</div>